"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Rego = require("@open-policy-agent/opa-wasm");
var dataprocessor_1 = require("./dataprocessor");
exports.parsePath = function (path) {
    var filepath = path;
    if (typeof path === 'object') {
        filepath = "" + Object.values(filepath).join('/');
    }
    // Check to see if file extension exists or is wrong
    // Only WASM file supported
    var split = filepath.split('.');
    if (split.length === 2 && split[1] === 'wasm') {
        return filepath;
    }
    if (split.length === 1) {
        return filepath + ".wasm";
    }
    throw new Error('Only WASM files are supported.');
};
/**
 * Loads a WASM-compiled .rego Open Policy Agent file from
 * the "@doordash/authz-policies" repo
 * @param path string or object defining file path
 */
exports.loadWasm = function (path) { return __awaiter(void 0, void 0, void 0, function () {
    var filepath, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                try {
                    filepath = exports.parsePath(path);
                }
                catch (error) {
                    // tslint:disable-next-line:no-console
                    console.error(error);
                    return [2 /*return*/, null];
                }
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                return [4 /*yield*/, Promise.resolve().then(function () { return require("@doordash/authz-policies/" + filepath); })];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                _a = _b.sent();
                // tslint:disable-next-line:no-console
                console.error("\u274C Unable to resolve import for WASM file.\n    Check to see that the file you're trying to\n    import exists or is a WASM file.");
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); };
/**
 * Evaluates a given OPA policy, given as WASM file, and input
 * @param path file path as string or object, referring to file in package
 * @param input object to feed into policy to determine output
 */
exports.evaluatePolicy = function (path, input) { return __awaiter(void 0, void 0, void 0, function () {
    var wasmPolicy, wasmBin, rego, loadedPolicy, result, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, exports.loadWasm(path)];
            case 1:
                wasmPolicy = _a.sent();
                return [4 /*yield*/, dataprocessor_1.processWasmPolicy(wasmPolicy)];
            case 2:
                wasmBin = _a.sent();
                rego = new Rego();
                return [4 /*yield*/, rego.load_policy(wasmBin)
                    // Provide a data document
                ];
            case 3:
                loadedPolicy = _a.sent();
                // Provide a data document
                loadedPolicy.set_data(input);
                result = loadedPolicy.evaluate(input);
                return [2 /*return*/, result[0].result];
            case 4:
                error_1 = _a.sent();
                throw new Error(error_1);
            case 5: return [2 /*return*/];
        }
    });
}); };
